// write a redux store for basic data immutablity ```javascript
import {configureStore} from '@reduxjs/toolkit'
import screenViewReducer from './screenViewSlice'
import paymentScreenViewReducer from './paymentScreenViewSlice'
import recurlyDataReducer from './recurlySlice'

export const store = configureStore({
  reducer: {
    screenView: screenViewReducer,
    paymentScreenView: paymentScreenViewReducer,
    recurlyTokenData: recurlyDataReducer,
  },
})
